import React from "react";
import { Link } from "react-router-dom";

const CategoryGrid = () => (

        <div className="section">
            <div className="easycontainer ">

            <div className="columns is-desktop has-text-3">

                <div className="column gridbox">
                    <Link to="/category/fitness">
                        <div className="verticalhelper">
                            <h1 className="has-text-primary">Fitness</h1>
                        </div>
                    </Link>
                </div>

                <div className="column gridbox">
                    <Link to="/category/health">
                        <div className="verticalhelper">
                            <h1 className="has-text-primary">Health</h1>
                        </div>
                    </Link>
                </div>

            </div>
        </div>

            <div className="easycontainer ">

                <div className="columns is-desktop has-text-3">

                  <div className="column gridbox">
                    <Link to="/category/steroids">
                      <div className="verticalhelper">
                        <h1 className="has-text-primary">Biohacking</h1>
                      </div>
                    </Link>
                  </div>

                    <div className="column gridbox">
                        <Link to="/category/selfimprovement">
                            <div className="verticalhelper">
                                <h1 className="has-text-primary">Self Improvement</h1>
                            </div>
                        </Link>
                    </div>

                </div>
            </div>
    </div>

);
export default CategoryGrid;